// extracted by mini-css-extract-plugin
export default {"option":"DonationOption_option__DOJxJ","selected":"DonationOption_selected__N9Lut","featured":"DonationOption_featured__mgNts"};